<template>
  <iframe title="pdf" :src="viewerUrl" width="100%" height="100%"/>
</template>

<script>
import { mapState } from 'vuex';
import 'pdfjs-dist/web/pdf_viewer.css';
import pdfjsLib from 'pdfjs-dist/webpack';

pdfjsLib.GlobalWorkerOptions.workerSrc = '../../build/browserify/pdf.worker.bundle.js';
export default {
  name: 'PDF',
  components: {
  },
  props: ['pdfUrl', 'useCase'],
  data: () => ({
    viewerUrl: undefined,
  }),
  computed: mapState([
    'runInfo',
  ]),
  methods: {
    fetchPdf() {
      // const exercise = this.run.exercises[0];
      switch (this.useCase) {
        case 'candidate':
          this.$api.exerciseDocuments.getDocument(this.pdfUrl).then(async (pdfDocumentRaw) => {
            const fileUrl = encodeURIComponent(URL.createObjectURL(pdfDocumentRaw));
            this.viewerUrl = `pdfViewer/web/viewer.html?file=${fileUrl}&beforePrint=false&startDownload=null`;
          })
          break;
        default:
          this.$api.run.getDocument(this.pdfUrl).then(async (pdfDocumentRaw) => {
            const fileUrl = encodeURIComponent(URL.createObjectURL(pdfDocumentRaw));
            this.viewerUrl = `pdfViewer/web/viewer.html?file=${fileUrl}&beforePrint=false&startDownload=null`;
          })
      }
    },
  },
  mounted() {
    this.fetchPdf();
  },
  beforeDestroy() {

  },
};
</script>
